import { createI18n } from 'vue-i18n'

// imports result in modules that are readonly
// -> creating a copy resolves that problem
const locales = JSON.parse(JSON.stringify(import.meta.glob('../locales/*.json', { eager: true })))

const availableLocales = Object.keys(locales).map(entry => {
    return entry
    .replace('../locales/', '')
    .replace('.json', '')
    .toLowerCase()
})

const _loadLocaleMessages = (clientLocales) => {
    const messages = {}

    availableLocales.forEach(key => {
        Object.keys(locales).forEach(localeFileName => {
            if (localeFileName.includes(key + '.json')) {
                messages[key] = locales[localeFileName]
            }
        })
    })

    // Kunden-Sprachdatei überschreibt die Sprach-Einträge im messages-Array(z.B. de wird von de_VVSFlisl.json überschrieben)
    if  (clientLocales) {
        clientLocales.forEach(locale => {
            let localeKey = Object.keys(locale)[0]

            if(messages[localeKey]) {
                for (const key in messages[localeKey]) {
                    if(Object.values(locale)[0][key]) {
                        messages[localeKey][key] = _mergeRecursive(messages[localeKey][key], Object.values(locale)[0][key])
                    }
                }
            }
        })
    }

    return messages
}

const _mergeRecursive = (target, source) => {
    Object.keys(source).forEach(param => {
        if (!target[param]) {
            // if the key does not exist in the first object, ignore it
            return
        } else if (source[param].constructor === Object) {
            // if the value is an object, merge it recursively
            target[param] = _mergeRecursive(target[param], source[param])
        } else {
            // else assign it
            target[param] = source[param]
        }
    })

    return target
}

const _getDefaultLocale = () => {
    let locale = 'de'

    const browserlocale = navigator.language.substring(0, 2).toLowerCase()

    if (availableLocales.includes(browserlocale)) {
        locale = browserlocale
    }

    return locale
}

const initI18n = (clientLocales) => {
    let locale           = _getDefaultLocale()
    const fallbackLocale = 'de'
    const messages       = _loadLocaleMessages(clientLocales)

    // If locale query parameter is a valid locale, use it
    const urlParams = new URLSearchParams(window.location.search)
    const queryParamLocale = urlParams.get('locale')

    if (queryParamLocale && availableLocales.includes(queryParamLocale.toLowerCase())) locale = queryParamLocale.toLowerCase()

    const i18n = createI18n({
        legacy: false,
        // allowComposition: true,
        locale,
        fallbackLocale,
        messages
    })

    return i18n
}

export {
    initI18n
}
